import { useEffect, useState } from 'react';

import { getDefaultAla, updateDefaultAla } from '../../api';

export function useDefaultAla() {
  const [level, updateLevel] = useState(1);
  const [loading, updateLoading] = useState({
    value: 1,
    label: 1,
  });


  useEffect(() => {
    const getDefault = async () => {
      updateLoading(true);
      const response = await getDefaultAla();
      updateLoading(false);

      if (!response) {
        return;
      }

      const newLevel = response < 0 ? 1 : response;
      updateLevel({
        value: newLevel,
        label: newLevel,
      });
    };

    getDefault();
  }, []);


  const saveAlaLevel = async () => {
    updateLoading(true);
    await updateDefaultAla(level.value);
    updateLoading(false);
  };

  return [level, updateLevel, loading, saveAlaLevel];
}
